import { createAsyncThunk } from '@reduxjs/toolkit';
import { pushToast } from '../reportingSlice';
import { PinReportApiResponse, PinReportPayload } from 'src/types/reportingTypes';

export const pinReport = createAsyncThunk<
	string,
	pinReport,
	{ rejectValue: string }
>(
	'reporting/pinReport',
	async ({ api, id, reqPayload }, { dispatch, rejectWithValue }) => {
		try {
			const response = await api.pinReport(id, reqPayload);
			dispatch(
				pushToast({
					type: 'success',
					message: 'Report pinned successfully',
				}),
			);
			return response.data.reportId;
		} catch (error) {
			const message =
				error instanceof Error
					? error.message
					: 'An unexpected error occurred';
			dispatch(
				pushToast({
					type: 'error',
					message:
						'Error on pinning report. Please try again after some time.',
				}),
			);
			return rejectWithValue(message);
		}
	},
);

type pinReport = {
	api: {
		pinReport: (id: string, reqPayload: PinReportPayload) => Promise<PinReportApiResponse>;
	};
	id: string;
	reqPayload: PinReportPayload;
};
